/**
 * `/apps/:appId/review` — how the course is actually going.
 *
 * A thin binding, like `grammar-lesson.tsx`: the screen itself is shared by both
 * courses, and the only per-course facts are the display name and which
 * languages its explanations read in.
 */
import { useParams } from 'react-router';

import { grammarCourseFor } from '@/apps';
import { GrammarReview } from '@/apps/shared/grammar/Review';
import { useAuxLanguages } from '@/lib/queries';

export function GrammarReviewRoute() {
  const { appId } = useParams<{ appId: string }>();
  const { primaryLang } = useAuxLanguages();
  const binding = grammarCourseFor(appId);

  if (!appId || !binding) {
    return (
      <main className="mx-auto w-full max-w-2xl px-4 py-6">
        <p className="text-destructive">That app has no lessons to review.</p>
      </main>
    );
  }

  return (
    <GrammarReview
      appId={appId}
      course={binding.course}
      displayName={binding.displayName}
      primaryLang={primaryLang}
    />
  );
}
